<div class="page-content page-fill flex-row">
  <div class="flex-row flex-fill">
    @if (invoices) {
      <div class="grid-fill reconciliation-data-grid" style="max-width: 99%">
        <dx-data-grid
          #dataGrid
          [dataSource]="invoices"
          keyExpr="id"
          height="100%"
          [showBorders]="true"
          [columnAutoWidth]="false"
          [focusedRowEnabled]="false"
          [showColumnLines]="true"
          [wordWrapEnabled]="true"
          (onToolbarPreparing)="onToolbarPreparing($event)"
          (onRowDblClick)="rowDoubleClick($event)"
          >
          <dxi-column dataField="id" caption="Id" width="60" [sortIndex]="1" [sortOrder]="'desc'" [alignment]="'left'"></dxi-column>
          <dxi-column dataField="invoiceNumber" caption="Invoice #" width="100"></dxi-column>
          <dxi-column dataField="name" caption="Name" width="280"></dxi-column>
          <dxi-column dataField="totalCalc" caption="Total" [format]="{ type: 'currency', precision: 2 }" width="110"></dxi-column>
          <dxi-column dataField="balance" caption="Balance" [format]="{ type: 'currency', precision: 2 }" width="110"></dxi-column>
          <dxi-column dataField="paidAmount" [format]="{ type: 'currency', precision: 2 }" width="110"></dxi-column>
          <dxi-column dataField="paid" width="110"></dxi-column>
          <dxi-column dataField="isPaid" width="110"></dxi-column>
          <dxi-column width="50"></dxi-column>
          <dxo-state-storing [enabled]="true" type="localStorage" storageKey="auction-purchases-list-grid"></dxo-state-storing>
          <dxo-filter-row [visible]="true"></dxo-filter-row>
          <dxo-selection [mode]="'single'"></dxo-selection>
          <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
          <div *dxTemplate="let data of 'toolbarButtons'">
            <button class="btn btn-success" (click)="open()" [disabled]="true">Add</button>
            <button
              class="btn btn-primary ms-2"
              (click)="open(dataGrid.instance.getSelectedRowsData()[0].id)"
              [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
              >
              Edit
            </button>
            <button
              class="btn btn-danger ms-2"
              (click)="delete(dataGrid.instance.getSelectedRowsData()[0])"
              [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
              >
              Delete
            </button>
            <!-- <button class="btn btn-success" (click)="addPurchase()">Record Purchase</button>
            <button
              class="btn btn-danger ms-2"
              (click)="delete(dataGrid.instance.getSelectedRowsData()[0])"
              [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
              >
              Delete Purchase
            </button> -->
          </div>
          <div *dxTemplate="let data of 'toolbarText'">
            @if (auctionPurchases) {
              <span class="me-3">
                <strong>{{ dataGrid.instance.totalCount() + " paddles" }}</strong>
              </span>
            }
          </div>
        </dx-data-grid>
      </div>
    }
  </div>
</div>
